import React, {useEffect} from "react";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import PostList from "../containers/PostList/PostList";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export default function AdminPostList() {
  const navigate = useNavigate();
  useEffect(() => {
    if(!cookies.get("authorization")){
      navigate("/")
    }
  }, [navigate])

  return (
    <div className="container">
      <Header />
      <PostList />
    </div>
  );
}
